import { Radio as RadioMantine } from '@mantine/core'
import React, { useCallback, useEffect, useMemo } from 'react'

import Input from '../../../../Mantine/Input'
import Radio from '../../../../Mantine/Radio'

import * as S from './styles'

const InputFilter = ({
  nome,
  localFilters,
  setLocalFilters,
  comRadio,
  setErroNosDados
}) => {
  const isClienteFinal = nome === 'CLIENTE_FINAL'
  const placeholder1 = isClienteFinal ? 'Código do cliente' : 'Min.'
  const placeholder2 = isClienteFinal ? 'Nome do cliente' : 'Max.'
  const campo1 = isClienteFinal ? 'CODIGO_CLIENTE' : 'MIN'
  const campo2 = isClienteFinal ? 'NOME_CLIENTE' : 'MAX'

  const handleRadioChange = useCallback(
    (value) => {
      setLocalFilters((prev) => {
        const newFilters = { ...prev[nome], TIPO: value }

        if (value === 'CODIGO_CLIENTE') {
          delete newFilters.NOME_CLIENTE
        } else if (value === 'NOME_CLIENTE') {
          delete newFilters.CODIGO_CLIENTE
        }

        return {
          ...prev,
          [nome]: newFilters
        }
      })
    },
    [setLocalFilters, nome]
  )

  const handleChange = useCallback(
    (campo, value) => {
      if (localFilters[nome]?.[campo] === value) return

      setLocalFilters((prev) => ({
        ...prev,
        [nome]: { ...prev[nome], [campo]: value }
      }))
    },
    [localFilters, setLocalFilters, nome]
  )

  const tipoFiltro = useMemo(
    () => localFilters[nome]?.TIPO || '',
    [localFilters, nome]
  )
  const MostrarSimboloRs = nome === 'VALOR'

  const minValue = localFilters[nome]?.MIN
  const maxValue = localFilters[nome]?.MAX

  const erroMinMaior = useMemo(() => {
    if (nome === 'VALOR') {
      return minValue && maxValue && Number(minValue) > Number(maxValue)
    }

    if (nome === 'ICCID_INTERVALO') {
      return false
    }

    return Number(minValue) > Number(maxValue)
  }, [minValue, maxValue, nome])

  useEffect(() => {
    setErroNosDados(erroMinMaior)
  }, [erroMinMaior, setErroNosDados])

  if (comRadio) {
    return (
      <S.InputRadioWrapper>
        <RadioMantine.Group
          name={nome}
          value={tipoFiltro}
          onChange={handleRadioChange}
        >
          <S.InputRadioGrupo>
            <Radio name="CLIENTE_FINAL" key={campo1} value={campo1} />
            <Radio name="CLIENTE_FINAL" key={campo2} value={campo2} />
          </S.InputRadioGrupo>
        </RadioMantine.Group>
        <S.InputWrapper>
          <Input
            maxLength={20}
            disabled={!tipoFiltro || (tipoFiltro && tipoFiltro !== campo1)}
            value={localFilters[nome]?.CODIGO_CLIENTE || ''}
            placeholder={placeholder1}
            onChange={(e) => handleChange(campo1, e.target.value)}
          />
          <Input
            maxLength={20}
            disabled={!tipoFiltro || (tipoFiltro && tipoFiltro !== campo2)}
            value={localFilters[nome]?.NOME_CLIENTE || ''}
            placeholder={placeholder2}
            onChange={(e) => handleChange(campo2, e.target.value)}
          />
        </S.InputWrapper>
      </S.InputRadioWrapper>
    )
  }

  const getRightSection = (value) => {
    if (nome === 'DIAS_UTILIZADOS') {
      return `${value === 1 ? 'Dia' : 'Dias'}`
    } else if (nome === 'SALDO') {
      return 'MB'
    }

    return null
  }

  return (
    <S.InputWrapper>
      <Input
        maxLength={20}
        type="number"
        rightSection={
          (nome === 'DIAS_UTILIZADOS' || nome === 'SALDO') && (
            <S.RightSection>
              {getRightSection(localFilters[nome]?.MIN)}
            </S.RightSection>
          )
        }
        icon={MostrarSimboloRs && <div>R$</div>}
        error={erroMinMaior}
        value={localFilters[nome]?.MIN || ''}
        placeholder={placeholder1}
        onChange={(e) => handleChange(campo1, e.target.value)}
      />
      <Input
        maxLength={20}
        type="number"
        rightSection={
          (nome === 'DIAS_UTILIZADOS' || nome === 'SALDO') && (
            <S.RightSection>
              {getRightSection(localFilters[nome]?.MAX)}
            </S.RightSection>
          )
        }
        icon={MostrarSimboloRs && <div>R$</div>}
        error={erroMinMaior}
        value={localFilters[nome]?.MAX || ''}
        placeholder={placeholder2}
        onChange={(e) => handleChange(campo2, e.target.value)}
      />
      {erroMinMaior && <S.Erro>Valor Máx. deve ser maior que Min.</S.Erro>}
    </S.InputWrapper>
  )
}

export default InputFilter
